export default "__VITE_ASSET__BX0F9f9P__"